import { SHOW_NOTIFICATION, NOTIFICATION_SHOWN, HIDE_NOTIFICATION } from '../types';

export const notify = (message = '?!?', type = 'info') => {
  return { 
    type: SHOW_NOTIFICATION,
    payload: { message, type }
  };
}

export const notified = () => {
  return { 
    type: NOTIFICATION_SHOWN
  };
}

export const hideNotification = () => {
  return { type: HIDE_NOTIFICATION };
}